import { applyUserPermissionsPayload } from "./permissionStorage";
import { normalizePermissionGroupIds } from "./permissionGroupMembership";

const trimTrailingSlash = (value) =>
  value ? String(value).replace(/\/$/, "") : "";

const API_BASE_URL =
  trimTrailingSlash(process.env.REACT_APP_API_URL);

const IMAGE_BASE_URL =
  trimTrailingSlash(process.env.REACT_APP_IMAGE_URL) || API_BASE_URL;

const SOCKET_BASE_URL =
  trimTrailingSlash(process.env.REACT_APP_SOCKET_URL);

const CLIENT_PORTAL_BASE_URL =
  trimTrailingSlash(process.env.REACT_APP_CLIENT_PORTAL_URL) ||
  "https://portal.aptitudemigration.com.au";

const PARTNER_PORTAL_BASE_URL =
  trimTrailingSlash(process.env.REACT_APP_PARTNER_PORTAL_URL) ||
  "https://partner.aptitudemigration.com.au";

export const main_url = () => API_BASE_URL;

export const image_url = () => IMAGE_BASE_URL;

export const socket_url = () => SOCKET_BASE_URL;

export const client_portal_url = () => CLIENT_PORTAL_BASE_URL;

export const partner_portal_url = () => PARTNER_PORTAL_BASE_URL;

export const getUser = () => {
  const userStr = localStorage.getItem("user");
  if (userStr) return JSON.parse(userStr);
};

export const isCurrentUserTeamLead = () => {
  const user = getUser();
  if (!user || typeof user !== "object") return false;

  const value =
    user.is_team_lead ??
    user.team_lead ??
    user.teamlead ??
    user.isTeamLead ??
    0;

  return value === true || value === 1 || value === "1";
};

export const getToken = () => {
  return localStorage.getItem("token") || null;
};

export const setUserSession = (token, user) => {
  localStorage.setItem("token", token);
  localStorage.setItem("user_id", JSON.stringify(user["id"]));
  localStorage.setItem("user", JSON.stringify(user));
  localStorage.setItem("user_role", JSON.stringify(user["role"]));
  const groupIds = normalizePermissionGroupIds(user);
  if (groupIds.length) {
    localStorage.setItem("permission_group_ids", JSON.stringify(groupIds));
    localStorage.setItem("permission_group_id", String(groupIds[0]));
    if (user?.permission_group_name) {
      localStorage.setItem(
        "permission_group_name",
        String(user.permission_group_name),
      );
    }
    if (Array.isArray(user?.permission_groups) && user.permission_groups.length) {
      localStorage.setItem(
        "permission_groups",
        JSON.stringify(user.permission_groups),
      );
    }
  } else {
    localStorage.removeItem("permission_group_id");
    localStorage.removeItem("permission_group_ids");
    localStorage.removeItem("permission_group_name");
    localStorage.removeItem("permission_groups");
  }
};

export const setUserPermissions = (permissions) => {
  applyUserPermissionsPayload(permissions);
};

export const removeUserSession = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("permissions");
  localStorage.clear();
};
